"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectDevice = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var IkeObjectDevice = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectDevice, _super);
    function IkeObjectDevice() {
        var _this = _super.call(this) || this;
        _this.className = 'Device';
        _this.actionName = 'device';
        _this.cacheKeys['deviceId'] = true;
        return _this;
    }
    return IkeObjectDevice;
}(base_1.IkeRestObject));
exports.IkeObjectDevice = IkeObjectDevice;
//# sourceMappingURL=device.objects.js.map